import { AnimatePresence, motion } from 'framer-motion';

import { DEFAULT_SUCCESS_MESSAGE } from '@/features/form-editing/components/constants/form-edit-constants';

interface ISuccessStateProps {
	successMessage?: string | null;
	displaySuccessState?: boolean;
}

function SuccessState({ displaySuccessState, successMessage }: ISuccessStateProps) {
	return (
		<AnimatePresence
			mode="wait"
			onExitComplete={() => null}
		>
			{displaySuccessState && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{
						duration: 0.3,
						ease: [0.4, 0, 0.2, 1],
					}}
					className="mt-3"
				>
					<p className="whitespace-pre-wrap">{successMessage || DEFAULT_SUCCESS_MESSAGE}</p>
				</motion.div>
			)}
		</AnimatePresence>
	);
}

export default SuccessState;
